import type { OnboardingSubscriptionPlan } from '@houzy/schemas/partner-cockpit/onboarding';
import {
    SubscriptionBillingCadence,
    SubscriptionPaymentMethod,
} from '@houzy/schemas/partner-management/partner-subscription-management';

const PLAN_PRESENTATION = [
    { tierKey: 'ONBOARDING.SUBSCRIPTION.TIER.STARTER', highlighted: false },
    { tierKey: 'ONBOARDING.SUBSCRIPTION.TIER.STANDARD', highlighted: false },
    { tierKey: 'ONBOARDING.SUBSCRIPTION.TIER.BEST_VALUE', highlighted: true },
] as const;

export type PlanPresentation = {
    tierKey: string | undefined;
    highlighted: boolean;
};

export function planPresentation(index: number): PlanPresentation {
    const entry = PLAN_PRESENTATION[index];
    return { tierKey: entry?.tierKey, highlighted: entry?.highlighted ?? false };
}

export type PlanFeature = {
    key: string;
    values?: Record<string, number>;
};

export function planFeatures(plan: OnboardingSubscriptionPlan): PlanFeature[] {
    const features: PlanFeature[] = [];

    if (plan.cadences.includes(SubscriptionBillingCadence.Monthly)) {
        features.push({
            key: 'ONBOARDING.SUBSCRIPTION.FEATURES.MINIMUM_COMMITMENT',
            values: { months: plan.commitmentLengthInMonths },
        });
        features.push({ key: 'ONBOARDING.SUBSCRIPTION.FEATURES.MONTHLY_PAYMENT' });
    } else {
        features.push({ key: 'ONBOARDING.SUBSCRIPTION.FEATURES.ONE_TIME_PAYMENT' });
    }

    if (
        plan.paymentMethods.includes(SubscriptionPaymentMethod.Card) ||
        plan.paymentMethods.includes(SubscriptionPaymentMethod.Twint)
    ) {
        features.push({ key: 'ONBOARDING.SUBSCRIPTION.FEATURES.CARD_OR_TWINT' });
    }
    if (plan.paymentMethods.includes(SubscriptionPaymentMethod.Invoice)) {
        features.push({ key: 'ONBOARDING.SUBSCRIPTION.FEATURES.INVOICE_AVAILABLE' });
    }

    return features;
}

export function defaultCadenceOf(plan: OnboardingSubscriptionPlan): SubscriptionBillingCadence {
    return plan.cadences.includes(SubscriptionBillingCadence.Monthly)
        ? SubscriptionBillingCadence.Monthly
        : SubscriptionBillingCadence.Upfront;
}
